import React from "react";
import LoadingSkeleton from "./LoadingSkeleton";

export default function LoadingPopoutSkeleton() {
  return (
    <>
      <div
        style={{
          position: "fixed",
          bottom: 24,
          right: 24,
          width: 460,
          minWidth: 280,
          maxWidth: 500,
          height: "80vh",
          zIndex: 1030,
          display: "flex",
          flexDirection: "column",
          borderRadius: 18,
          overflow: "hidden",
          boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
          border: "2px solid #E0E0E0",
          background: "#fff",
          padding: 4,
        }}
      >
        <LoadingSkeleton />
      </div>
    </>
  );
}
